﻿export interface IOrgan {
    id: number;
    name: string;
}
